// @ts-nocheck
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { makeStyles, lighten, List, ListItem } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Modal from '@dev-togetherprice/components.modal';
const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'Poppins',
        width: '100%',
        border: `1px solid ${lighten(theme.palette.primary.main, 0.5)}`,
        borderRadius: theme.spacing(2),
        cursor: 'pointer',
        position: 'relative',
    },
    option: {
        fontFamily: 'Poppins',
    },
    preview: {
        opacity: ({ hasValue }) => (hasValue ? 1 : 0.42),
        padding: theme.spacing(4.625, 2.5),
    },
    arrow: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: 5,
    },
    list: {},
}));
const Select = ({ placeholder, options, defaultValue, classes: newClasses = {}, onChange, }) => {
    // defaultValue
    const [selected, setSelected] = useState(defaultValue);
    const [show, setShow] = useState(false);
    const baseClasses = useStyles({ hasValue: !!selected });
    const classes = mergeClasses({ newClasses, baseClasses, Component: Select });
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.preview, onClick: () => setShow(true) },
            selected
                ? options.find((i) => i.value === selected).name
                : placeholder,
            show ? (React.createElement(ArrowDropUpIcon, { className: classes.arrow })) : (React.createElement(ArrowDropDownIcon, { className: classes.arrow }))),
        React.createElement(Modal, { open: show, onClose: () => setShow(false) },
            React.createElement(List, { className: classes.list }, options === null || options === void 0 ? void 0 : options.map(({ name, value: val }) => (React.createElement(ListItem, { key: val, className: classes.option, button: true, onClick: () => {
                    setShow(false);
                    setSelected(val);
                    onChange(val);
                } }, name)))))));
};
export default Select;
